import {isFeatureEnabled} from 'feature-flags';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetInterestV2Query} from '@dms/api/finance';
import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {
  CommentsTab,
  ActivitySidebarV2,
  ActivitySidebarAction,
  CommunicationThreadTab,
} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';
import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {buildArray} from 'shared/web';

import {ActivityTab} from './components/ActivityTab';

interface InterestActivityPanelProps {
  interestId: string;
}

export function InterestActivityPanel(props: InterestActivityPanelProps) {
  const {data: interest} = useGetInterestV2Query({id: props.interestId});

  const [canReadSalesActivities] = usePermissions({
    permissionKeys: ['readSalesActivities'],
  });

  const actions = buildArray<ActivitySidebarAction>()
    .when(canReadSalesActivities, {
      id: 'activity',
      label: i18n.t('entity.activityPanel.activity.title'),
      icon: 'sidebar/activity',
      component: <ActivityTab interestId={props.interestId} />,
    })
    .when(
      canReadSalesActivities &&
        isFeatureEnabled(featureFlags.MESSAGE_SYNCHRONIZATION) &&
        isNotNilOrEmpty(interest?.customerId),
      {
        id: 'communication',
        label: i18n.t('entity.activityPanel.communicationThread.title'),
        icon: 'communication/thread',
        component: (
          <CommunicationThreadTab
            customerId={interest?.customerId ?? ''}
            recordId={props.interestId}
            resourceId={EntityResourceIds.interest}
          />
        ),
        disablePadding: true,
      }
    )
    .when(canReadSalesActivities, {
      id: 'comments',
      label: i18n.t('entity.activityPanel.comments.title'),
      icon: 'communication/comment',
      component: <CommentsTab interestId={props.interestId} />,
    })
    .whenFeatureEnabled(
      featureFlags.CUSTOM_NOTICES,
      buildCustomNoticesSidebarAction({
        resourceId: EntityResourceIds.interest,
        recordId: props.interestId,
      })
    );

  return <ActivitySidebarV2 actions={actions} />;
}
